import { Box, Button, styled } from "@mui/material";

export const MessagesWrapper = styled(Box)`
  padding-left: 16px;
  padding-right: 16px;

  @media (min-width: 992px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const StepsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`;

export const StepItem = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background-color: rgba(0, 123, 255, 0.1);
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  word-wrap: break-word;
  animation: fadeIn 0.5s ease-in-out;

  &.fade-out {
    animation: fadeOut 0.4s ease-in-out forwards;
  }

  &:before {
    content: "•";
    color: #007bff;
    font-weight: bold;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px) scale(0.95);
    }
  }
`;

export const FinalMessageContainer = styled(Box)`
  animation: fadeInMessage 0.6s ease-in-out;

  @keyframes fadeInMessage {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

export const AddStepButton = styled(Button)`
  background-color: #007bff;
  color: white;
  border-radius: 6px;
  text-transform: none;
  font-size: 13px;
  padding: 8px 16px;

  &:hover {
    background-color: #0056b3;
  }
`;

export const ClearStepsButton = styled(Button)`
  background-color: #dc3545;
  color: white;
  border-radius: 6px;
  text-transform: none;
  font-size: 13px;
  padding: 8px 16px;

  &:hover {
    background-color: #c82333;
  }
`;
